module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskAdd2-ee5b916a1dcd3d3cf762dbcb22ea5431.jpg";